import SamplesRelabelDialog from './SamplesRelabelDialog';

export default SamplesRelabelDialog;
